import { Modal } from "antd";
import React from "react";
import { RotatingLines } from "react-loader-spinner";

interface IProcessingModal {
	visible: boolean;
}

const ProcessingModal: React.FC<IProcessingModal> = ({ visible }) => {
	return (
		<Modal open={visible} footer={null} zIndex={1500}>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					justifySelf: "center",
					alignSelf: "center",
				}}
			>
				<div style={{ marginBottom: 20, fontWeight: "bold", fontSize: "16px" }}>
					Por favor aguarde, estamos processando sua requisição.
				</div>
				<div
					style={{
						width: "100%",
						padding: "0 44%",
					}}
				>
					<RotatingLines
						strokeColor="#63b8cd"
						strokeWidth="5"
						animationDuration="0.75"
						width="64"
						visible={true}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default ProcessingModal;
